import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EmailTemplate } from 'src/app/model/emailTemplate.modals';
import { EmailnotificationService } from 'src/app/services/emailnotification.service';
import { AlertService } from '../../services/alert.service';
import { AccessControlService } from 'src/app/services/access-control.service';
import { NgxEditorModule } from 'ngx-editor';
import { FormControl } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap';
import { TemplateTypesEnum } from '../../enum/email-templates.enum'
@Component({
  selector: 'app-addtemplate',
  templateUrl: './addtemplate.component.html',
  styleUrls: ['./addtemplate.component.css']
})
export class AddtemplateComponent implements OnInit {
   emailTemplateOptions:any=[]
   emailTemplateModel: EmailTemplate = new EmailTemplate();
   templateId: any;
   opt: string;
   applicationlist: any;
   orgId:any;
   availableTemplateOptions:any=[]
   templatesUsed:any=[]
   allTemplatesSetForApp:boolean=false
   allTemplatesSetForOrg:boolean=false
   allTemplatesSetForTenet:boolean=false
   modalRef:any;
   type:string;
   isLoading:boolean
   isSavingData:boolean=false
   buttonText:string
  constructor(private router: Router,
    private toastService:ToastrService,
    private activatedRoute: ActivatedRoute,
    private accessControlService: AccessControlService,
    private emailnotificationService: EmailnotificationService,
    private modalService:BsModalService) {
    this.opt = this.activatedRoute.snapshot.queryParamMap.get('opt')
    this.type=this.activatedRoute.snapshot.queryParamMap.get('type')
  }

  ngOnInit() {
    localStorage.setItem('option','notificationManager');
    this.orgId=localStorage.getItem('org_id')
    this.getEmailTemplateOptions(this.type)
    if(this.type==TemplateTypesEnum.APPLICATION) this.getAssignedApllications()
    if (this.opt == 'add') {
      this.buttonText="Save"
     // this.emailTemplateModel = new EmailTemplate();
      //this.emailTemplateModel.templateId=null
    }
    else {
      this.buttonText="Update"
      this.templateId = this.activatedRoute.snapshot.params['id'];
      this.getTemplateById();
    }
  }

  getApplicationListByOrgId() {
    this.accessControlService.listallapplications().subscribe((res) => {
      this.applicationlist = res;
    },
      error => {
        console.log(
          'Error in getting applications'
        )
      });
  }

  saveEmailTemplate(form) {
    if(form.invalid) return
    this.isSavingData=true
    if(this.type==TemplateTypesEnum.APPLICATION) this.emailTemplateModel.type=TemplateTypesEnum.APPLICATION
    else if(this.type==TemplateTypesEnum.ORGANIZATION)this.emailTemplateModel.type=TemplateTypesEnum.ORGANIZATION
    else if(this.type==TemplateTypesEnum.TENET) this.emailTemplateModel.type=TemplateTypesEnum.TENET
    else this.emailTemplateModel.type=null
    if (this.opt == 'add') {
      this.emailTemplateModel.organization_id=localStorage.getItem('org_id')
      this.emailnotificationService.saveEmailTemplate(this.emailTemplateModel).subscribe((res) => {
      }, error => {
        this.isSavingData=false
        var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
        this.toastService.error(errorMessage)
      }, () => {
        this.isSavingData=false
        this.toastService.success("Email Template Added Successfully")
        this.router.navigate(['/emailtemplate']);
      });
    }
    else {
      this.emailnotificationService.updateTemplate(this.emailTemplateModel).subscribe((res) => {
      }, error => {
        this.isSavingData=false
        var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
        this.toastService.error(errorMessage)
      }, () => {
        this.isSavingData=false
        this.toastService.success("Email Template Updated Successfully")
        this.router.navigate(['/emailtemplate']);
      });

    }
  }

  getTemplateById() {
    this.isLoading=true
    this.emailnotificationService.getEmailTemplate(this.templateId).subscribe((res: any) => {
      this.emailTemplateModel = res;
      this.emailTemplateModel.availableMergeFields=res.templateId.mergeFields
      this.emailTemplateModel.templateId=res.templateId._id
      this.isLoading=false
    },
      error => {
        this.isLoading=false
        console.log(
          'Error in getting template'
        )
      });
  }
  getEmailTemplateOptions(type){
    this.isLoading=true
    this.emailnotificationService.getEmailTemplateOptions(type,this.orgId).subscribe(
      (response:any)=>{
        if(!response.error){
          this.emailTemplateOptions=response.data.availabeOptions
          this.availableTemplateOptions=response.data.availabeOptions
          this.templatesUsed=response.data.templatesUsed
          if(this.type==TemplateTypesEnum.ORGANIZATION || this.type==TemplateTypesEnum.TENET) this.checkOrganizationTemplatesOptions()
        }
         this.isLoading=false
      },
      (err)=>{ this.isLoading=false}
    )
  }
  setDefaults(){
    const defaultSetting=this.emailTemplateOptions.find((template)=>{
      return template._id==this.emailTemplateModel.templateId
    })
    this.emailTemplateModel.subject=defaultSetting.subject
    this.emailTemplateModel.emailBody=defaultSetting.templateBody
    this.emailTemplateModel.availableMergeFields=defaultSetting.mergeFields.toString()
  }
  checkApplicationTemplateOptions(appId,temp,form){
    this.allTemplatesSetForApp=false
    this.emailTemplateOptions=[...this.availableTemplateOptions]
    const optionsLength=this.emailTemplateOptions.length
    for(let i=0;i<this.availableTemplateOptions.length;i++){
      for(let j=0;j<this.templatesUsed.length;j++){
        if(this.availableTemplateOptions[i]._id==this.templatesUsed[j].templateId && this.templatesUsed[j].application_id==appId){
          this.emailTemplateOptions=this.emailTemplateOptions.filter((option)=>{
            return option._id !=this.templatesUsed[j].templateId
          })
        }
      }
    }
    const selectedTemplateId=this.emailTemplateOptions.find((options)=>{
      return this.emailTemplateModel.templateId==options._id
    })
    if(optionsLength!=this.emailTemplateOptions.length && !selectedTemplateId){
      if(temp)temp.reset()
      this.emailTemplateModel.emailBody=''
      this.emailTemplateModel.availableMergeFields=''
      this.emailTemplateModel.subject=''
      this.emailTemplateModel.isActive=false
    }
    if(this.emailTemplateOptions.length<=0){
      const selectedApp=this.emailTemplateModel.application_id
      form.reset()
      this.allTemplatesSetForApp=true
      this.emailTemplateModel.application_id=selectedApp
    }

  }
  getApplicationName(id:string){
    if(this.applicationlist){
      const application = this.applicationlist.find((application)=>{
        return application.appDetails._id==id
      })
      return application?application.appDetails.application_name:''
    }
    return ''
  }
  getTemplateName(id:string){
    if(this.emailTemplateOptions){
      const options= this.emailTemplateOptions.find((option)=>{
        return option._id==id
      })
      return options?options.templateName:''
    }
    return ''

  }
  getAssignedApllications() {
    const clientId=localStorage.getItem('user_id')
    this.accessControlService.getAssignedApplications(clientId).subscribe((res:any) => {
      console.log(res)
      this.applicationlist = res.applications;
    },
      error => {
        console.log(
          'Error in getting applications'
        )
      });
  }
  previewEmailBody(template){
    this.modalRef=this.modalService.show(template,{})
  }
  closeModel(){
    this.modalRef.hide()
  }
  checkOrganizationTemplatesOptions(){
  if(this.opt=="add"){
    for(let i=0;i<this.availableTemplateOptions.length;i++){
      for(let j=0;j<this.templatesUsed.length;j++){
        if(this.availableTemplateOptions[i]._id==this.templatesUsed[j].templateId){
          this.emailTemplateOptions=this.emailTemplateOptions.filter((option)=>{
            return option._id !=this.templatesUsed[j].templateId
          })
        }
      }
    }
    if(this.emailTemplateOptions.length<=0) this.allTemplatesSetForOrg=true
   }
  }
}
